import { FC, useEffect, useState } from 'react'
import { push } from 'connected-react-router'
import { isFulfilled } from '@reduxjs/toolkit'

import CustomButton from '../../components/UI/Buttons/CustomButton'
import CustomPopup from '../../components/UI/Popup'
import Radio from '../../components/UI/Inputs/Radio/Simple'

import {
  TGetLinkedinAuthorizedPagesPayload,
  TProjectSocialLinkedin,
  TLinkedinAccountDetails as TLinkedinPage,
  TPostChoosePageFromTheListReturnedByGetLinkedinAuthorizedPagesPayload
} from '../../store/project/types'
import {
  getLinkedinAuthorizedPagesThunk,
  postChoosePageFromTheListReturnedByGetLinkedinAuthorizedPagesThunk
} from '../../store/project/thunks'
import { useDispatch, useSelector } from '../../store/index'

import Linkedin from '../../assets/img/socials/linkedin.svg'

import './ConnectSocialAccounts.scss'
import { generatePath } from 'react-router'
import { AUTH_ROUTE } from '../App/routes'
import { addProjectSocialAction } from '../../store/agency/slice'
import { TAddProjectSocialPayload } from '../../store/agency/types'
import { addProjectSocialToCurrentProject, chooseProjectAction } from '../../store/project/slice'
import { setUserRoleAction } from '../../store/auth/slice'

interface ICallBack {}

const LinkedinCallBack: FC<ICallBack> = (props) => {
  const dispatch = useDispatch()
  const { projects, code, state } = useSelector(
    ({ agency: { projects }, router: { location } }) => {
      const code: string = (location as any).query.code
      const state: string = (location as any).query.state
      return { projects, code, state }
    }
  )

  const [pagesForChoice, setPagesForChoice] = useState<null | TLinkedinPage[]>(null)
  const [projectToAddSocial, setProjectToAddSocial] = useState<number>(0)
  const [chosenOrganizationLinkedin, setChosenOrganizationLinkedin] = useState<string>('')
  const [count, setCount] = useState<number>(0)

  useEffect(()=>{
    if (code && state) {
      setCount(count + 1)
    }
  },[code, state])

  useEffect(() => {
    if (code && state && count == 1) {
      connectLinkedin()
    }
  }, [code, state, count])

  const connectLinkedin = async () => {
    try {
      const payloadLinkedin: TGetLinkedinAuthorizedPagesPayload = {
        state: state,
        code: code
      }
      const responseGetLinkedinAuthorizedPagesThunk = await dispatch(
        getLinkedinAuthorizedPagesThunk(payloadLinkedin)
      )

      if (isFulfilled(responseGetLinkedinAuthorizedPagesThunk)) {
        const {
          payload: {
            data: { project_social: projectSocial, pages, project_id: projectId }
          }
        } = responseGetLinkedinAuthorizedPagesThunk

        setProjectToAddSocial(projectId)

        if (projectSocial) {
          const projectSocialPayload: TProjectSocialLinkedin = projectSocial
          const projectId = projectSocialPayload.project_id
          const payload: TAddProjectSocialPayload = {
            projectId: projectId,
            projectSocial: projectSocialPayload
          }
          const project = projects.find(({ id }) => projectId === id)
          if (project) {
            dispatch(setUserRoleAction(project.role))
            dispatch(chooseProjectAction(project))
            dispatch(addProjectSocialToCurrentProject(payload))
          }
          dispatch(addProjectSocialAction(payload))
          dispatch(
            push(
              generatePath(AUTH_ROUTE.SOCIAL_ACCOUNTS, {
                projectId: projectId
              })
            )
          )
        } else {
          setPagesForChoice(pages)
        }
      }
    } catch (e) {
      console.error(e)
    }
  }

  const chooseSocialNetworkPage = async () => {
    try {
      const payloadLinkedin: TPostChoosePageFromTheListReturnedByGetLinkedinAuthorizedPagesPayload =
        {
          project_id: projectToAddSocial,
          organization: chosenOrganizationLinkedin
        }
      const responsePostChoosePageFromTheListReturnedByGetLinkedinAuthorizedPages = await dispatch(
        postChoosePageFromTheListReturnedByGetLinkedinAuthorizedPagesThunk(payloadLinkedin)
      )

      if (isFulfilled(responsePostChoosePageFromTheListReturnedByGetLinkedinAuthorizedPages)) {
        const {
          payload: { data: linkedinPage }
        } = responsePostChoosePageFromTheListReturnedByGetLinkedinAuthorizedPages

        const projectId = linkedinPage.project_id
        const payload: TAddProjectSocialPayload = {
          projectId: projectId,
          projectSocial: linkedinPage
        }
        const project = projects.find(({ id }) => projectId === id)
        if (project) {
          dispatch(setUserRoleAction(project.role))
          dispatch(chooseProjectAction(project))
          dispatch(addProjectSocialToCurrentProject(payload))
        }
        dispatch(addProjectSocialAction(payload))
        dispatch(
          push(
            generatePath(AUTH_ROUTE.SOCIAL_ACCOUNTS, {
              projectId: projectId as number
            })
          )
        )
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className='page-container'>
      <CustomPopup
        open={Boolean(pagesForChoice)}
        closeOnDocumentClick={false}
        className='page-choice-modal'
      >
        <div className='page-choice-modal-wrapper'>
          Choose your page
          <div className='page-choice-modal_pages'>
            {pagesForChoice &&
              pagesForChoice.map(({ organizationName, organization }) => (
                <div key={organization} className='add-post_accounts'>
                  <div className='account'>
                    <div className='account_user-info'>
                      <img className='account_user-info_icon' alt='avatar' src={Linkedin}></img>
                      <div className='account_user-info_name'>{organizationName}</div>
                    </div>
                    <Radio
                      checked={chosenOrganizationLinkedin === organization}
                      handleChange={({ value }: { value: string }) =>
                        setChosenOrganizationLinkedin(value)
                      }
                      value={organization}
                      name='chosePage'
                    />
                  </div>
                </div>
              ))}
          </div>
          <div className='page-choice-modal_actions'>
            <CustomButton
              type='button'
              button='primary'
              disabled={!chosenOrganizationLinkedin}
              onClick={chooseSocialNetworkPage}
            >
              Connect
            </CustomButton>
          </div>
        </div>
      </CustomPopup>
    </div>
  )
}

export default LinkedinCallBack
